export default "__VITE_ASSET__C0P2jyuv__"